<template>
  <div id="app-root">
    <RouterView />
  </div>
</template>

<script>
import 'vuetify/dist/vuetify.min.css';
import '@src/design/ck-editor-content-styles.css';
import '@src/design/jw-json-viwer-theme.scss';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

// import '@src/design/themes/themeLight.css';
import '@src/design/themes/themeDark.css';
import '@src/design/themes/themeExtra.css';

// import 'primeflex/primeflex.scss';
import 'primeflex/primeflex.css'; // Tem algum lugar do sistema que buga ao usar o primeflex
import 'nprogress/nprogress.css';

import '@src/design/global.scss';

import {appConfig} from '@src/config';
const fcmI18n = require('@i18n/index');

const {languages} = fcmI18n;

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  }),
  page() {
    return {
      titleTemplate(title) {
        title = typeof title === 'function' ? title(this.$store) : title;
        return title ? `${title} | ${appConfig.title}` : appConfig.title;
      },
      meta: this.metaComputed,
      link: this.linkComputed,
    };
  },
  computed:{
    metaComputed() {
      const metaRet = [];
      metaRet.push({property: 'og:locale', content: this.$i18n.locale});
      for(const language in languages) {
        metaRet.push({property: 'og:locale:alternate', content: language});
      }
      return metaRet;
    },
    linkComputed() {
      const metaRet = [];
      if(this.$router.currentRoute) {
        metaRet.push({ rel: 'canonical', href: appConfig.baseUrl+'/'+this.$router.currentRoute.fullPath });
        metaRet.push({ rel: 'og:url', href: appConfig.baseUrl+'/'+this.$router.currentRoute.fullPath });
        for(const language in languages) {
          metaRet.push({ rel: 'alternate', href: appConfig.baseUrl+'/'+this.$router.currentRoute.fullPath+'?locale='+language, hreflang: language });
        }
      }
      return metaRet;
    }
  },
};
</script>
<style lang="scss">

//html {
//  overflow-x: auto!important;
//}

@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap');

</style>

